// extracted by mini-css-extract-plugin
module.exports = {"option":"styles_option__iFTfh","selected":"styles_selected__0pOMY","note":"styles_note__qvpD0"};